import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Liitu ja kingime sulle kohe 500 €

  <span style="color:#85c1dc;">**FI:**</span>
  Rekisteröidy ja saat heti 500 €

  <span style="color:#85c1dc;">**RU:**</span>
  Присоединяйся и получите 500 € сразу
*/
/* @__NO_SIDE_EFFECTS__ */
const m1056 = msg(
  mf`Liitu ja kingime sulle kohe 500 €`,
  mf`Rekisteröidy ja saat heti 500 €`,
  mf`Присоединяйся и получите 500 € сразу`,
)

export { m1056 as 'w.header.menu.new-customer-benefit' }